module.exports = __webpack_public_path__ + "static/img/logo-省供销合作社联合社.e3ec55c0.png";